package top.wcpe.allincore.ui.runtime.ir.api

import kotlin.jvm.JvmField

/**
 * DSL 内建对象 `session` 暴露的方法集（仅命令式方法走此通道）。
 * `session.x = ...` / `session.x` 这类字段读写在编译期被识别为
 * SessionRef / SessionAssign，不走 MemberCall。
 */
fun interface SessionApi {
    /** 清空当前玩家 + 服务器作用域内的所有 session 字段（一般仅供调试 / 测试使用）。 */
    fun clear()

    companion object {
        /** 默认实现：clear() 不做任何动作。 */
        @JvmField
        val NOOP: SessionApi = SessionApi {}
    }
}
